export default __webpack_public_path__ + "static/speaker3-979e7b77ac5930e32cf80add0c42c520.jpg";